import React, { useEffect, useState } from 'react';
import CompanyInfoEdit from './Edit';
import SupplierDetail from '@/mpc-common/containers/SupplierMgr/component/SupplierDetailNew';
import { connect } from 'react-redux';

const EditEntrance = (props: any) => {
    const { suppliersList } = props
    const [isNewSupplier, setIsNewSupplier] = useState(false)
    useEffect(() => {
        const supplier = suppliersList.find((v: any) => v.selected)
        setIsNewSupplier(supplier?.is_new)
    }, [suppliersList])
    return <>
        {isNewSupplier ? <SupplierDetail {...props} /> : <CompanyInfoEdit {...props} />}
    </>
}

const mapStateToProps = (state: any) => {
    return {
        suppliersList: state.account.suppliersList,
    }
}

const mapDispatchToProps = () => {
    return {}
};

export default connect(mapStateToProps, mapDispatchToProps)(EditEntrance);
